import {useState} from 'react';
import {getLang, langKey} from "../utils/helper";

const useLang = () => {
    const rtlLangs = ["ar", "kr"];
    const [lang, setLang] = useState(getLang());
    const saveLang = (lang) => {
        localStorage.setItem(langKey, lang)
        setLang(lang)
    }
    const toggleDirection = (dir) => document.body.dir = dir;
    return {
        lang,
        setLang: saveLang,
        toggleDirection,
        rtlLangs
    };
}

export default useLang;
